<template>
    <h1>MALL</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>